import {
    ResourceManager,
    ComponentManager,
    LabelViewModel,
    ImageViewModel,
    ButtonViewModel,
    WindowViewModel,
    MessageBoxViewModel,
} from 'radpresentation.htmlclient.defaultviewextensions';
const locator = 'notice-message';
const windowLocator = 'window';
const imageLocator = 'content.image';
const labelLocator = 'content.label';

const headlineErgname = 'RADEM.RADEXTENSIONMANAGER.DELETECONFIRMATIONTITLE';
const captionErgname = 'RADEM.RADEXTENSIONMANAGER.DELETEPROPERTYCONFIRMATION';

const imageSource = 'message_warning.png';
const yes = 'YES';
const no = 'NO';

class DeletePropertyMessageBoxViewModel extends MessageBoxViewModel {
    public static yesCallback() {}

    public constructor(
        propertyName: string,
        typeName: string,
        locator: string
    ) {
        let label = new LabelViewModel({
            parentLocator: locator,
            locator: locator + '.' + labelLocator,
            caption: ResourceManager.getInstance()
                .get(captionErgname)
                .replace('{0}', propertyName)
                .replace('{1}', typeName),
        });

        let yesButton = new ButtonViewModel({
            label: LabelViewModel.create(yes),
            onClick: () => {
                this.window.isOpen(false);
                DeletePropertyMessageBoxViewModel.yesCallback();
            },
            locator: locator + '.button.yes',
        });

        let noButton = new ButtonViewModel({
            label: LabelViewModel.create(no),
            onClick: () => {
                this.window.isOpen(false);
            },
            locator: locator + '.button.no',
        });

        let image = new ImageViewModel({
            parentLocator: locator,
            locator: locator + '.' + imageLocator,
            source: imageSource,
        });

        let window = new WindowViewModel({
            parentLocator: locator,
            locator: locator + '.' + windowLocator,
            width: 620,
            isModal: true,
            isOpen: true,
            allowClose: true,
            headline: new LabelViewModel({
                ergName: headlineErgname,
            }),
        });

        super({
            window: window,
            image: image,
            label: label,
            buttons: [yesButton, noButton],
        });
    }
}

export default DeletePropertyMessageBoxViewModel;
ComponentManager.setViewModel(
    'DeletePropertyMessageBoxViewModel',
    DeletePropertyMessageBoxViewModel,
    'RADExtensionManagerHTMLViewExtension'
);
